<template>
  <div class="manageCardAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnManageCardList')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <!-- 姓名 -->
        <el-form-item :label="$t('lang.lbl_fkgl_userName')" prop="userName">
          <el-input v-model="ruleForm.userName" :placeholder="$t('lang.plh.input')+$t('lang.lbl_fkgl_userName')"
            class="item-input" style="width:30%"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item :label="$t('lang.lbl_fkgl_mobile')" prop="mobile">
          <el-input v-model="ruleForm.mobile" :placeholder="$t('lang.plh.input')+$t('lang.lbl_fkgl_mobile')"
            class="item-input" style="width:30%"></el-input>
        </el-form-item>
        <!-- 人员类型 -->
        <el-form-item :label="$t('lang.lbl_fkgl_peopleType')" prop="department">
          <el-select class="select" v-model="ruleForm.department" :placeholder="$t('lang.CARDTYPE.TYPE[0].label')">
            <el-option v-for="item in departmentList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择园区 -->
        <el-form-item :label="$t('lang.lbl_fkgl_garden')" prop="gardenId">
          <el-select class="select" v-model="ruleForm.gardenId" @change="selectHouse" disabled>
            <el-option key :label="$t('lang.lab_selectVillage')" value="0"></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择楼号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_house')" prop="houseId">
          <el-select class="select" v-model="ruleForm.houseId" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value="0"></el-option>
            <el-option v-for="(item,index) in houseList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择单元号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_unit')" prop="unitId">
          <el-select v-model="ruleForm.unitId" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value="0"></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择房间号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_room')" prop="roomId">
          <el-select v-model="ruleForm.roomId">
            <el-option key :label="$t('lang.lab_roomName')" value="0"></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 卡类型 -->
        <el-form-item :label="$t('lang.lbl_fkgl_cardType')" prop="cardType">
          <el-select @change='changeCardType' class="select" v-model="ruleForm.cardType"
            :placeholder="$t('lang.CARDTYPE.TYPE[0].label')">
            <el-option v-for="item in cardTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 通行设备 -->
        <el-form-item :label="$t('lang.lbl_fkgl_goDevice')" prop="goDevice">
          <el-select class="select" multiple collapse-tags :multiple-limit=maxDeviceNum v-model="ruleForm.goDevice"
            :placeholder="$t('lang.CARDTYPE.TYPE[0].label')" style="width:30%">
            <el-option v-for="item in deviceList" :key="item.id.toString()" :label="item.eqName"
              :value="item.id.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 通行楼层 -->
        <el-form-item :label="$t('lang.lbl_fkgl_goFloor')" prop="goFloor">
          <el-select class="select" multiple collapse-tags v-model="ruleForm.goFloor"
            :placeholder="$t('lang.lbl_fkgl_goFloorSelect')" style="width:30%">
            <el-option v-for="item in passFloorList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 卡有效期限 -->
        <el-form-item tem :label="$t('lang.lbl_fkgl_cardValidityDate')" prop="cardValidityDate">
          <div class="block">
            <el-date-picker v-model="ruleForm.cardValidityDate" type="date" value-format="timestamp" placeholder="卡有效期">
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:manageCardAdd
   *@Description:新增发卡
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2021-09-01
   */
  export default {
    data() {
      return {
        saveData: '',
        clears: false,
        isFlag: false, // 新增修改标识（false为新增，true为修改）
        type: 1, // 楼号单元号房间号区分
        gardenId: this.$store.getters.gardenId, // 当前园区id
        gardens: [], // 小区下拉列表
        houseList: [], // 楼号下拉列表
        unitList: [], // 单元下拉列表
        roomList: [], // 房间下拉列表
        departmentList: this.$i18n.t('lang.DEMPARTMENT.TYPE'), // 人员类型列表
        cardTypeList: this.$i18n.t('lang.CARDTYPE.TYPE'), // 卡类型列表
        deviceList: [], // 通行设备列表
        passFloorList: this.$i18n.t('lang.PASSFLOOR.NUMBER'), // 通行楼层列表
        maxDeviceNum: 23, // 可选择最多设备数
        rules: {
          userName: [{
            required: true,
            message: this.$i18n.t('lang.lbl_fkgl_userNameSelect'),
            trigger: 'blur'
          }],
          cardType: [{
            required: true,
            message: this.$i18n.t('lang.lbl_fkgl_cardTypeSelect'),
            trigger: 'change'
          }],
          goDevice: [{
            required: true,
            message: this.$i18n.t('lang.lbl_fkgl_goDeviceSelect'),
            trigger: 'change'
          }],
          goFloor: [{
            required: true,
            message: this.$i18n.t('lang.lbl_fkgl_goFloorSelect'),
            trigger: 'change'
          }],
          cardValidityDate: [{
            required: true,
            message: this.$i18n.t('lang.lbl_fkgl_cardValidityDateSelect'),
            trigger: 'change'
          }],
        },
        ruleForm: {
          id: '', // id
          userName: '', // 姓名
          mobile: '', // 电话
          department: '', // 人员类型
          gardenId: this.$store.getters.gardenId, // 小区绑定值
          houseId: '0', // 楼号绑定值
          unitId: '0', // 单元绑定值
          roomId: '0', // 房间绑定值
          cardType: '', // 卡类型
          goDevice: [], // 通行设备
          goFloor: [], // 通行楼层
          cardValidityDate: '', // 卡有效期
        },
      }
    },
    computed: {

    },
    destroyed() {
      window.localStorage.setItem('manageCardForm', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('manageCardSaveData', JSON.stringify(this.saveData))
    },
    created() {
      this.getGArdens()
      this.selectHouse()
      this.getDevicelist()
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (this.isFlag) {
        this.getData()
      }
      if (window.localStorage.getItem('manageCardForm')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('manageCardForm'))
        if (window.localStorage.getItem('manageCardSaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('manageCardSaveData'))
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'manageCardList'
        })
      },
      // 获取园区列表
      getGArdens() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过小区选择楼号
      selectHouse() {
        this.type = 1
        this.ruleForm.houseId = '0'
        this.ruleForm.unitId = '0'
        this.ruleForm.roomId = '0'
        this.unitList = []
        this.roomList = []
        this.houseList = []
        this.gardenGrids(this.ruleForm.gardenId, 1)
      },
      // 通过楼号选择单元号
      selectUnit() {
        this.type = 2
        this.ruleForm.unitId = '0'
        this.ruleForm.roomId = '0'
        this.roomList = []
        this.unitList = []
        this.gardenGrids(this.ruleForm.houseId, 2)
      },
      // 通过单元选择房间号
      selectRoom() {
        this.roomList = []
        this.type = 3
        this.ruleForm.roomId = '0'
        this.gardenGrids(this.ruleForm.unitId, 3)
      },
      // 通过园区id查询楼号楼层房间号
      gardenGrids(gardenid, type) {
        if (gardenid == '0' || gardenid == '') {
          return
        }
        this.$get(
          `/gardenGrids?type=${type}&pageSize=999&pageNo=1&parentId=${gardenid}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (type === 1) {
                this.houseList = res.list
              } else if (type === 2) {
                this.unitList = res.list
              } else if (type === 3) {
                this.roomList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 修改卡类型，全通卡选择所有设备和楼层权限
      changeCardType(e) {
        if (e == 3) {
          this.ruleForm.goDevice = this.deviceList.map(item => {
            return item.id
          }).join(',').split(',')
          this.ruleForm.goFloor = this.passFloorList.map(item => {
            return item.value
          }).join(',').split(',')
          console.log(this.ruleForm)
        }
      },
      // 通行设备列表
      getDevicelist() {
        let loading = this.$loading()
        this.$get(
          `/xl/equipment/?gardenId=${this.gardenId}&pageNo=1&pageSize=999`
        ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.deviceList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.id
        this.ruleForm.userName = this.$route.query.object.userName
        this.ruleForm.mobile = this.$route.query.object.mobile
        this.ruleForm.department = this.$route.query.object.department
        this.ruleForm.gardenId = this.$store.getters.gardenId
        this.ruleForm.houseId = this.$route.query.object.houseId == 0 ? '0' : this.$route.query.object.houseId
        this.ruleForm.unitId = this.$route.query.object.unitId == 0 ? '0' : this.$route.query.object.unitId
        this.ruleForm.roomId = this.$route.query.object.roomId == 0 ? '0' : this.$route.query.object.roomId
        this.ruleForm.cardType = this.$route.query.object.cardType
        this.ruleForm.goDevice = this.$route.query.object.xlEquipmentId.split(',')
        this.ruleForm.goFloor = this.$route.query.object.floor.split(',')
        this.ruleForm.cardValidityDate = this.$route.query.object.endTime
        console.log('getData', this.ruleForm)
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
        if (this.ruleForm.gardenId) {
          this.type = 1
          this.gardenGrids(this.ruleForm.gardenId, 1)
        }
        if (this.ruleForm.houseId) {
          this.type = 2
          this.gardenGrids(this.ruleForm.houseId, 2)
        }
        if (this.ruleForm.unitId) {
          this.type = 3
          this.gardenGrids(this.ruleForm.unitId, 3)
        }
      },
      // 保存
      save(formName) {
        let params = {}
        params.userName = this.ruleForm.userName
        params.mobile = this.ruleForm.mobile
        params.department = this.ruleForm.department
        params.gardenId = this.ruleForm.gardenId
        params.houseId = this.ruleForm.houseId
        params.unitId = this.ruleForm.unitId
        params.roomId = this.ruleForm.roomId
        params.cardType = this.ruleForm.cardType
        params.xlEquipmentId = this.ruleForm.goDevice.join(',')
        params.floor = this.ruleForm.goFloor.sort((a, b) => {
          return a - b
        }).join(',')
        params.endTs = this.ruleForm.cardValidityDate
        console.log(params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (this.isFlag) {
              // 编辑
              this.$patch(`/xl/information/${this.ruleForm.id}`, params).then(
                res => {
                  console.log(res)
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'manageCardList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 新增
              this.$post('/xl/information', params).then(
                res => {
                  console.log(res)
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'manageCardList'
                    })
                  }
                  var index = this.$keepAlive.indexOf('/manage/main.manageCardList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.userName = ''
        this.ruleForm.mobile = ''
        this.ruleForm.department = ''
        this.ruleForm.gardenId = this.$store.getters.gardenId
        this.ruleForm.houseId = '0'
        this.ruleForm.unitId = '0'
        this.ruleForm.roomId = '0'
        this.ruleForm.cardType = ''
        this.ruleForm.goDevice = []
        this.ruleForm.goFloor = []
        this.ruleForm.cardValidityDate = ''
      },
    },
  }
</script>

<style lang="scss">
  .proprietorNotificationEdit {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>